// Generated by scripts/generate-operation-catalog.mjs. Do not edit directly.
export const OPERATION_CATALOG_VERSION = 1;
export const COLLECTION_OPERATIONS = [
    "describe",
    "changes",
    "read",
    "query",
    "list_views",
    "execute_view",
    "read_view_source",
    "create_view_source",
    "update_view_source",
    "delete_view_source",
    "validate",
    "create",
    "update",
    "delete",
    "rename",
    "read_type",
    "create_type",
    "update_type",
    "assess_type_pack",
    "apply_type_pack",
    "assess_collection_setup",
    "apply_collection_setup",
    "list_timers",
    "put_timer",
    "cancel_timer",
    "reconcile_timers",
    "sync"
];
export const FILE_CONTROL_MESSAGE_TYPES = [
    "list_files",
    "open_file_upload",
    "open_file_download",
    "move_file",
    "delete_file",
    "get_file_transfer_status",
    "commit_file_upload",
    "abort_file_transfer"
];
const COLLECTION_MUTATION_RULES = {
    "describe": "never",
    "changes": "never",
    "read": "never",
    "query": "never",
    "list_views": "never",
    "execute_view": "never",
    "read_view_source": "never",
    "create_view_source": "always",
    "update_view_source": "always",
    "delete_view_source": "always",
    "validate": "never",
    "create": "always",
    "update": "always",
    "delete": "always",
    "rename": "always",
    "read_type": "never",
    "create_type": "always",
    "update_type": "always",
    "assess_type_pack": "never",
    "apply_type_pack": "always",
    "assess_collection_setup": "never",
    "apply_collection_setup": "always",
    "list_timers": "never",
    "put_timer": "always",
    "cancel_timer": "always",
    "reconcile_timers": "always",
    "sync": "sync_action"
};
const COLLECTION_INPUT_SCHEMA_VERSIONS = {
    "describe": 1,
    "changes": 1,
    "read": 1,
    "query": 1,
    "list_views": 1,
    "execute_view": 1,
    "read_view_source": 1,
    "create_view_source": 1,
    "update_view_source": 1,
    "delete_view_source": 1,
    "validate": 1,
    "create": 1,
    "update": 1,
    "delete": 1,
    "rename": 1,
    "read_type": 1,
    "create_type": 1,
    "update_type": 1,
    "assess_type_pack": 1,
    "apply_type_pack": 1,
    "assess_collection_setup": 1,
    "apply_collection_setup": 1,
    "list_timers": 1,
    "put_timer": 1,
    "cancel_timer": 1,
    "reconcile_timers": 1,
    "sync": 1
};
const FILE_CONTROL_INPUT_SCHEMA_VERSIONS = {
    "list_files": 1,
    "open_file_upload": 1,
    "open_file_download": 1,
    "move_file": 1,
    "delete_file": 1,
    "get_file_transfer_status": 1,
    "commit_file_upload": 1,
    "abort_file_transfer": 1
};
const MUTATING_FILE_CONTROL_MESSAGE_TYPES = new Set([
    "open_file_upload",
    "move_file",
    "delete_file",
    "commit_file_upload",
    "abort_file_transfer"
]);
const NONMUTATING_DRY_RUN_OPERATIONS = new Set([
    "delete",
    "rename"
]);
export const MUTATING_OPERATION_IDENTIFIERS = [
    "create_view_source",
    "update_view_source",
    "delete_view_source",
    "create",
    "update",
    "delete",
    "rename",
    "create_type",
    "update_type",
    "apply_type_pack",
    "apply_collection_setup",
    "put_timer",
    "cancel_timer",
    "reconcile_timers",
    "sync:mutate",
    "file_control:open_file_upload",
    "file_control:move_file",
    "file_control:delete_file",
    "file_control:commit_file_upload",
    "file_control:abort_file_transfer"
];
const TIMER_CRITERION_OPERATIONS = new Set([
    "list_timers",
    "put_timer",
    "cancel_timer",
    "reconcile_timers"
]);
const COLLECTION_OPERATION_SET = new Set(COLLECTION_OPERATIONS);
const FILE_CONTROL_MESSAGE_TYPE_SET = new Set(FILE_CONTROL_MESSAGE_TYPES);
export function isCollectionOperation(value) {
    return COLLECTION_OPERATION_SET.has(value);
}
export function areCollectionOperations(values) {
    return values.every(isCollectionOperation);
}
export function operationRequiresTimerCriterion(operation) {
    return TIMER_CRITERION_OPERATIONS.has(operation);
}
export function isFileControlMessageType(value) {
    return FILE_CONTROL_MESSAGE_TYPE_SET.has(value);
}
export function operationInputSchemaVersion(operation, input) {
    if (operation === "file_control") {
        const type = isObject(input) && typeof input.type === "string" ? input.type : "";
        if (!isFileControlMessageType(type))
            throw new Error(`Unknown file-control message: ${type}`);
        return FILE_CONTROL_INPUT_SCHEMA_VERSIONS[type];
    }
    return COLLECTION_INPUT_SCHEMA_VERSIONS[operation];
}
export function mutationOperationIdentifier(operation, input) {
    const object = isObject(input) ? input : {};
    if (object.dry_run === true && NONMUTATING_DRY_RUN_OPERATIONS.has(operation))
        return null;
    if (operation === "file_control") {
        const type = typeof object.type === "string" ? object.type : "";
        return MUTATING_FILE_CONTROL_MESSAGE_TYPES.has(type)
            ? `file_control:${type}`
            : null;
    }
    const rule = COLLECTION_MUTATION_RULES[operation];
    if (rule === "always")
        return operation;
    if (rule === "sync_action" && object.action === "mutate")
        return "sync:mutate";
    return null;
}
export function isMutatingOperation(operation, input) {
    return mutationOperationIdentifier(operation, input) !== null;
}
function isObject(value) {
    return value !== null && typeof value === "object" && !Array.isArray(value);
}
